export const populateTemplate = (template: string, data: any) => {
  const pattern = /{\s*(\w+?)\s*}/g;
  return template?.replace(pattern, (_, token) => data[token] || '');
}